import { ErrorBoundary_default } from './chunk-NJFJDBQA.js';
import { ThemeProvider } from './chunk-J2FXRRBJ.js';
import { __spreadValues } from './chunk-2FEJBM4N.js';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

var CustomTypo = styled((props) => /* @__PURE__ */ React.createElement(Typography, __spreadValues({ variant: "h3" }, props)))(({
  fs,
  fw,
  c,
  lh,
  color
}) => {
  const tempObj = {
    fontSize: fs || 16,
    fontWeight: fw || 600,
    color: c || color || "#000000"
  };
  if (lh) tempObj["lineHeight"] = lh;
  return tempObj;
});
function CustomTypoContainer(props) {
  return /* @__PURE__ */ React.createElement(ErrorBoundary_default, { componentName: "CustomTypoContainer" }, /* @__PURE__ */ React.createElement(ThemeProvider, null, /* @__PURE__ */ React.createElement(
    Box,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%"
      }
    },
    /* @__PURE__ */ React.createElement(CustomTypo, __spreadValues({}, props))
  )));
}
function TypoContainer({
  children,
  sx
}) {
  return /* @__PURE__ */ React.createElement(ErrorBoundary_default, { componentName: "TypoContainer" }, /* @__PURE__ */ React.createElement(ThemeProvider, null, /* @__PURE__ */ React.createElement(
    Box,
    {
      sx: __spreadValues({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center"
      }, sx)
    },
    children
  )));
}
function StyledTypo(props) {
  return /* @__PURE__ */ React.createElement(ErrorBoundary_default, { componentName: "Typo" }, /* @__PURE__ */ React.createElement(ThemeProvider, null, /* @__PURE__ */ React.createElement(CustomTypo, __spreadValues({}, props))));
}
var StyledTypo_default = StyledTypo;

export { CustomTypoContainer, StyledTypo_default, TypoContainer };
//# sourceMappingURL=chunk-MYGKM72Z.js.map
//# sourceMappingURL=chunk-MYGKM72Z.js.map